import React from 'react'
import { Container, Box, Typography } from '@mui/material'

export default function multiGame() {
  return (
    <>
    <Container>
        <Box>
            <Typography>Multi</Typography>
        </Box>
    </Container>
    </>
  )
}
